module.exports = __webpack_public_path__ + "static/media/RCImg4.23baa79b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RCImg4.jpg
// module id = 1165
// module chunks = 0